import { Component } from '@angular/core';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {SettingsService} from "../service/settings.service";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatListModule} from "@angular/material/list";
import {MatSelectModule} from "@angular/material/select";
import {MatOptionModule} from "@angular/material/core";
import {NgClass, NgForOf} from "@angular/common";
import {ThemeService} from "../service/theme.service";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {FormsModule} from "@angular/forms";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {translation} from "../translation";
import packageInfo from '../../../package.json';

@Component({
  selector: 'app-settings-manager',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule, MatIconModule, MatCardModule, MatFormFieldModule, MatListModule, MatSelectModule, MatOptionModule, NgForOf, NgClass, MatSlideToggleModule, FormsModule, MatButtonToggleGroup, MatButtonToggle, MatCheckboxModule],
  templateUrl: './settings-manager.component.html',
  styleUrl: './settings-manager.component.scss'
})
export class SettingsManagerComponent {

  instrumentKeys: string[] = [];
  appVersion: string = (packageInfo as any).version ?? '';

  constructor(protected settingService: SettingsService, protected themeService: ThemeService) {
    // initialize list of instruments (excluding random/none)
    this.instrumentKeys = this.settingService.getAllInstrumentKeys();
  }
  toggleSettingSidenav() {
    this.settingService.toggleSettings();
  }

  ngOnInit(): void {
  }

  // --- Instruments enable/disable management ---
  isInstrumentEnabled(key: string): boolean {
    return this.settingService.isInstrumentEnabled(key);
  }

  getInstrumentName(key: string): string {
    const map: any = {
      piano: translation.instrument.piano,
      organ: translation.instrument.organ,
      violin: translation.instrument.violin,
      harp: translation.instrument.harp,
      flute: translation.instrument.flute,
      guitar: translation.instrument.guitar,
      ensemble: translation.instrument.ensemble,
      electric_piano: translation.instrument.electric_piano,
      synth: translation.instrument.synth,
      voice: translation.instrument.voice,
      music_box: translation.instrument.music_box,
    };
    return map[key] || key;
  }

  async onToggleInstrument(key: string) {
    const enabled = this.settingService.getEnabledInstruments();
    const isEnabled = enabled.includes(key);
    if (isEnabled && enabled.length === 1) {
      // prevent disabling the last instrument
      return;
    }
    await this.settingService.setInstrumentEnabled(key, !isEnabled);
  }

  clearFavorites() {
    if (confirm(translation.clear_favorites_confirm)) {
      this.settingService.clearFavorites();
    }
  }

  clearHymnsToLearn() {
    if (confirm(translation.clear_hymns_to_learn_confirm)) {
      this.settingService.clearHymnsToLearn();
    }
  }

  clearHistory() {
    if (confirm(translation.clear_history_confirm)) {
      this.settingService.clearHistory();
    }
  }

  toggleBackgroundBlur() {
    this.settingService.setThemeBlurEnabled(!this.settingService.getThemeBlurEnabled());
  }

  toggleBackgroundImage() {
    this.settingService.setThemeBackgroundEnabled(!this.settingService.getThemeBackgroundEnabled());
  }

  toggleTextOutlines() {
    this.settingService.setTextOutlineEnabled(!this.settingService.getTextOutlineEnabled());
  }

  toggleIntro() {
    this.settingService.setIntroEnabled(!this.settingService.getIntroEnabled());
  }

  onKeepAwakeChange() {
    this.settingService.setKeepAwake(!this.settingService.getKeepAwake());
  }

    protected readonly translation = translation;
}
